export default [
  'codigoUnico',
  'descricao',
]
